import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";

import "./index.css";
import Header from "./components/Header.tsx";
import Footer from "./components/Footer.tsx";

import ScrollToTop from "./components/ScrollToTop.tsx";

import Home from "./pages/Home.tsx";
import About from "./pages/About.tsx";
import Contact from "./pages/Contact.tsx";
import Complaints from "./pages/Complaints.tsx";
import PageNotFound from "./pages/PageNotFound.tsx";

import DailyLiving from "./pages/DailyLiving.tsx";
import CommunityAccess from "./pages/CommunityAccess.tsx";
import Nursing from "./pages/Nursing.tsx";
import Transport from "./pages/Transport.tsx";
import ExercisePhysiology from "./pages/ExercisePhysiology.tsx";
import SIL from "./pages/SIL.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        <Route
          path="/services/support-with-daily-living"
          element={<DailyLiving />}
        />
        <Route
          path="/services/community-access"
          element={<CommunityAccess />}
        />
        <Route path="/services/nursing" element={<Nursing />} />
        <Route path="/services/transport" element={<Transport />} />
        <Route
          path="/services/exercise-physiology"
          element={<ExercisePhysiology />}
        />
        <Route
          path="/services/supported-independent-living"
          element={<SIL />}
        />

        <Route path="/contact/complaints" element={<Complaints />} />
        <Route path="/*" element={<PageNotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  </StrictMode>,
);
